export const headerNav = [
  { label: 'Home', hasMenu: false },
  { label: 'Programs', hasMenu: true },
  { label: 'Coaches', hasMenu: true },
  { label: 'Store', hasMenu: true },
  { label: 'Blog', hasMenu: false },
  { label: 'About Us', hasMenu: true },
  { label: 'Contact', hasMenu: true },
];

export const footerColumns = [
  {
    title: 'About',
    links: ['About i9 Sports', 'The i9 Sports® Experience', 'How We’re Different', 'Sportsmanship Values', 'Parental Pledge', 'Sports We Play', 'Frequently Asked Questions'],
  },
  {
    title: 'Parents',
    links: ['Register For A Program', 'Dashboard', 'My Schedule', 'Trophy Case', 'Maps & Directions', 'Refer A Friend'],
  },
  {
    title: 'Coaches',
    links: ['Become A Coach', 'Volunteer Application', 'Coaches Training', 'Coaching Resources', 'Soccer Resources', 'Flag Football Resources'],
  },
  {
    title: 'Store Categories',
    links: ['Store', 'Uniform Bottoms', 'Bundles', 'Shop By Sport', 'Children’s Apparel', 'Clearance'],
  },
  {
    title: 'Contact Us',
    links: ['Frequently Asked Questions', 'Employment Opportunities', 'Media Inquiries', 'Local Office Phone', 'Weather Hotline', 'Franchise Opportunities'],
  },
];

export const socialLinks = ['Facebook', 'Instagram', 'Twitter', 'YouTube', 'Pinterest', 'LinkedIn'];
